import { Component } from '@angular/core';
import { ReportService } from '../../services/report.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { IReport, IResponse } from '@interfaces/index';
import { switchMap } from 'rxjs';
import { AppRoutingService } from '@ui-components/services';
import { reportPdfFilename } from '@ui-components/report';

const ADMIN_ORIGIN_PARAM_VALUE = 'admin';

@Component({
  selector: 'app-view-assessment',
  templateUrl: './view-assessment.component.html',
  styleUrl: './view-assessment.component.scss'
})
export class ViewAssessmentComponent {

  loading = false;
  report: IReport | null = null;
  download = false;
  fromAdmin = false;
  backHref: string | null = null;

  constructor(
    protected _report_service: ReportService,
    protected _app_routing_service: AppRoutingService,
    protected _route: ActivatedRoute,
    protected _router: Router
  ){}

  ngOnInit() {
    this.loading = true;
    this.fromAdmin = this._route.snapshot.queryParamMap.get('from') === ADMIN_ORIGIN_PARAM_VALUE;
    this.backHref = this.fromAdmin ? this._app_routing_service.getAdminUrl('assessments') : null;
    this._route.params.pipe(
      switchMap(
        (params: Params) => {
          return this._report_service.getReport(params["report_id"]);
        }
      )
    ).subscribe(
      (response: IResponse<IReport>) => {
        this.report = response.data;
        this.loading = false;
      }
    )
  }

  downloadReport() {
    this.download = true;

    setTimeout(() => {
      const reportElement = document.getElementById('document');

      if (this.report && reportElement) {
        this._report_service.downloadReport(reportElement.innerHTML).subscribe({
          next: (response) => {
            const url = window.URL.createObjectURL(response);
            const downloadLink = document.createElement('a');
            downloadLink.href = url;
            downloadLink.download = reportPdfFilename(this.report);

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            window.URL.revokeObjectURL(url);
            this.download = false;

            this._navigateBack();
          },
          error: (error) => {
            console.error('Error downloading report:', error);
            this.download = false;
          }
        });
      } else {
        console.error('Report or reportElement is null');
        this.download = false;
      }

    }, 500);
  }

  private _navigateBack(): void {
    if (this.fromAdmin && this.backHref) {
      window.location.href = this.backHref;
    } else {
      this._router.navigate(['/']);
    }
  }
}
